import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content-grid content-grid--subpage" }

import {ref} from "vue";
import {useI18n} from "vue3-i18n";
import {useContactService} from "@/inversify.config";
import {Contact} from "@/types/entities/contact";
import Breadcrumbs from "@/components/layout/Breadcrumbs.vue";
import BackLinkTitle from "@/components/layout/BackLinkTitle.vue";
import Card from "@/components/layout/Card.vue";
import ContactForm from "@/components/forms/ContactForm.vue";
import {notifyError, notifySuccess} from "@/notify";
import {useRouter} from "vue-router";
import {useMemberStore} from "@/stores/memberStore";

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'EditContactForm',
  props: {
    organizationId: {},
    contactId: {}
  },
  async setup(__props: any) {

let __temp: any, __restore: any

const props = __props;

const {t} = useI18n()
const router = useRouter()
const memberStore = useMemberStore()
const contactService = useContactService()

const organizationId = props.organizationId ? props.organizationId : memberStore.getMember.organizationId

const contact = ref<Contact>((
  ([__temp,__restore] = _withAsyncContext(() => contactService.getContact(organizationId, props.contactId))),
  __temp = await __temp,
  __restore(),
  __temp
));

async function handleSubmit(contact: Contact) {
    let succeededOrNotResponse = await contactService.updateContact(contact, organizationId)
    if (succeededOrNotResponse && succeededOrNotResponse.succeeded) {
        notifySuccess(t('validation.contact.edit.success'))
        setTimeout(() => {
            router.back();
        }, 1500);
    } else {
        let errorMessages = succeededOrNotResponse.getErrorMessages('validation.contact.edit');
        if (errorMessages.length == 0)
          notifyError(t('validation.contact.edit.errorOccurred'))
        else
          notifyError(errorMessages[0])
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Breadcrumbs, {
      title: _unref(t)(`routes.admin.children.organizations.editContact.name`)
    }, null, 8, ["title"]),
    _createVNode(BackLinkTitle, {
      title: _unref(t)(`routes.admin.children.organizations.editContact.name`)
    }, null, 8, ["title"]),
    _createVNode(Card, null, {
      default: _withCtx(() => [
        _createVNode(ContactForm, {
          id: _unref(organizationId),
          onFormSubmit: handleSubmit,
          contact: contact.value
        }, null, 8, ["id", "contact"])
      ]),
      _: 1
    })
  ]))
}
}

})